import * as Constants from '../common/constants';

export class BaseParameter {
	OrderBy: string;
	PageIndex: number;
	PageSize: number;
	ViewMode: string;
	
	constructor(pageIndex?: number | null
		, pageSize?: number | null
		, orderBy?: string | null) {
		this.PageIndex = pageIndex;
		this.PageSize = pageSize;
		this.OrderBy = orderBy || '';
	}
	
	useMaxValue() {
		this.PageSize = Constants.PAGINATION_SIZE_MAX;
	}
	
	toLowerCase(): Promise<any> {
		let asignedParam: any = {};
		for (let key in this) {
			asignedParam[key.toLowerCase()] = this[key];
		}
		return Promise.resolve(asignedParam);
	}
	
	setPageIndex(pageIndex: number) {
		this.PageIndex = pageIndex;
	}
	
	setPageSize(pageSize: number) {
		this.PageSize = pageSize;
	}
}

export class GenericBaseParameter<TCondition> extends BaseParameter {
	Fields: string;
	Condition: TCondition;
	ViewMode: string;
    Cache?: boolean;
    FilterCondition?: {
        Fields: Array<{Name: string; Value: string, DataType?: number}>
    }
	constructor(pageIndex?: number , pageSize?: number , orderBy?: string , fields?: string, condition?: TCondition) {
		super(
			pageIndex || Constants.PAGINATION_INDEX
			, pageSize || Constants.PAGINATION_SIZE
			, orderBy || orderBy);
		
		this.Condition = condition || ({} as TCondition);
		this.Fields = fields;
		this.ViewMode = 'Grid';
        this.Cache = true;
        this.FilterCondition = {
            Fields: []
        }
	}
	
	record(value: any, key: string) {
		this[key] = value;
	}
}

//FIXME
export interface ISmartSearchCondition<T> {
	OrderBy?: string;
	PageIndex?: number;
	PageSize?: number;
	ViewMode?: string;
	Fields?: string;
	Condition?: T;
	
	useMaxValue?: () => void;
	setPageIndex?: (pageIndex: number) => void;
	setPageSize?: (pageSize: number) => void;
	toLowerCase?: () => Promise<any>;
}

export class SmartSearchCondition<T> implements ISmartSearchCondition<T> {
	OrderBy?: string;
	PageIndex?: number;
	PageSize?: number;
	ViewMode?: string;
	Fields?: string;
	Condition?: T;
	
	constructor(props: ISmartSearchCondition<T>) {
		this.OrderBy = props.OrderBy || null;
		this.PageIndex = props.PageIndex || 0;
		this.PageSize = props.PageSize || 0;
		this.ViewMode = props.ViewMode || "Grid";
		this.Fields = props.Fields || "*";
		this.Condition = props.Condition;
	}
	
	useMaxValue() {
		this.PageSize = Constants.PAGINATION_SIZE_MAX;
	}
	
	toLowerCase(): Promise<any> {
		let asignedParam: any = {};
		for (let key in this) {
			asignedParam[key.toLowerCase()] = this[key];
		}
		return Promise.resolve(asignedParam);
	}
	
	setPageIndex(pageIndex: number) {
		this.PageIndex = pageIndex;
	}
	
	setPageSize(pageSize: number) {
		this.PageSize = pageSize;
	}
}